export const ReportDetailsModalComponent = {
    template: /*html*/`
        <div class="modal-header">
            <h1>Report Details</h1>
        </div>
        <div class="modal-body">
            <h3 class="h3">Options</h3>
            <apex-report-job-parameters job="$ctrl.resolve.job"></apex-report-job-parameters>
            <h3 class="h3">Progress</h3>
            <apex-report-progress job="$ctrl.resolve.job"></apex-report-progress>
        </div>
        <div class="modal-footer">
            <button type="button"
                    class="btn btn-plain"
                    ng-click="$ctrl.close({ $value: 'cancel' })">
                Close
            </button>
        </div>
    `,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

export const ReportDetailsModal = {
    component: "apexReportDetailsModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static',
}
